import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation UpdateProjectMutation($input: UpdateProjectMutationInput!) {
        updateProject(input: $input) {
            project {
                serviceId
                createdDate
                installDate
                name
                portfolio {
                    serviceId
                    name
                }
                purchaserId
                shippingAddress {
                    city
                    country
                    formattedAddress
                    line1
                    line2
                    state
                    zipCode
                }
                sourcingStartDate
                userId
            }
        }
    }
`;

export function commit(environment, args) {
    const { installDate, name, onCompleted, onError, shippingAddress, projectId } = args;

    return commitMutation(environment, {
        mutation,
        variables: {
            input: {
                installDate,
                name,
                projectId,
                shippingAddress,
            },
        },
        onCompleted,
        onError,
    });
}
